var map = {
	"./banma.js": 1565,
	"./blackfish.js": 1566,
	"./default.js": 382,
	"./fenqile.js": 1567,
	"./guanaitong.js": 1568,
	"./hebeiyidong.js": 1569,
	"./nonghang.js": 1570,
	"./pufabank.js": 1571,
	"./yixiaoyuan.js": 1572,
	"./zhaohang.js": 1573
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2449;


//////////////////
// WEBPACK FOOTER
// ./src/mods/channels ^(.*\.(js$))[^.]*$/i
// module id = 2449
// module chunks = 148